import { Box, Pagination } from "@mui/material";

import { useNetworkFiltersState } from "../../hooks/useNetworkFiltersState";
import { useNetworkData } from "../../hooks/useNetworkData";

import NetworkTabs from "./NetworkTabs";
import NetworkFilters from "./NetworkFilters";
import NetworkPersonas from "./NetworkPersonas";
import NetworkListing from "./NetworkListing";

const NetworkTab = ({ userId, entityId }: { userId?: string; entityId?: string }) => {
  const { network, queryString, hasActiveFilters, filters, updateFilters } = useNetworkFiltersState();
  const { isLoading, data } = useNetworkData({ userId, entityId, network, queryString });

  const handlePageChange = (_event: React.ChangeEvent<unknown>, newPage: number) => {
    const newOffset = (newPage - 1) * (filters.limit || 10);
    updateFilters("offset", newOffset.toString());
  };

  const currentPage = data?.meta ? Math.floor((filters.offset || 0) / (filters.limit || 9)) + 1 : 1;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        border: "1px solid #EAECF0",
        background: "#FFF",
        padding: "20px",
      }}
    >
      <NetworkTabs isDataLoading={isLoading} />
      <NetworkPersonas isDataLoading={isLoading} />
      <NetworkFilters isDataLoading={isLoading} />
      <NetworkListing users={data?.items} isLoading={isLoading} hasActiveFilters={hasActiveFilters} />
      {data?.meta && data.meta.totalPages > 1 && (
        <Pagination
          count={data.meta.totalPages}
          page={currentPage}
          onChange={handlePageChange}
          sx={{
            marginBottom: "45px",
            direction: "ltr !important",
            "& .MuiButtonBase-root": {
              borderRadius: "8px !important",
            },
            "& .MuiPagination-ul": {
              justifyContent: "center",
            },
          }}
        />
      )}
    </Box>
  );
};

export default NetworkTab;
